import * as React from 'react';
import { Bar } from 'recharts';

export const setBar = (transfer: boolean): any => {
    if(transfer) {
      return (
          <Bar yAxisId="left" dataKey="no response yet" fill="#e91e63" />
      )
    } else {
      return '';
    }
  }


// WEBPACK FOOTER //
// ./src/components/AreaChart/utils/setBar.tsx